/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3 10.0867V4.7802l8.25-3.173 8.25 3.173v5.5191c0 4.159-.4351 7.9307-2.9467 10.1616C15.2655 21.6049 13.5458 22.5 11.25 22.5c-2.587 0-4.4673-1.2794-5.8277-2.8443C3.3608 17.2841 3 13.8515 3 10.0867Zm-1.5 0V3.75L11.25 0 21 3.75v6.5493c0 4.1059-.3808 8.5563-3.4505 11.2831C16.042 22.9215 13.9803 24 11.25 24c-3.1527 0-5.4139-1.5818-6.9597-3.3602C1.8273 17.8064 1.5 13.841 1.5 10.0867Zm14.8144-1.3428a.75.75 0 1 0-1.1288-.9878l-4.7221 5.3967-2.4332-2.4331a.75.75 0 0 0-1.0606 1.0606l3 3 .5668.5669.5279-.6033 5.25-6Z"
    clipRule="evenodd"
  />,
  'Secured'
);
